export class AddressModel {
    id: number;
    address1: string;
    address2: string;
    state: string;
    regionId: number;
    city: string;
    zipCode: string;
    country: string;
    latitude: string;
    longitude: string;
    isSameOfficeAddress: boolean;

    constructor(data?) {
        if (data) {
            this.id = data.id;
            this.address1 = data.address1;
            this.address2 = data.address2;
            this.state = data.state;
            this.regionId = data.regionId;
            this.city = data.city;
            this.zipCode = data.zipCode;
            this.country = data.country;
            this.latitude = data.latitude;
            this.longitude = data.longitude;
            this.isSameOfficeAddress = data.sameAddressAs;
        }
    }
}
